import { render, staticRenderFns } from "./ICMOERelease.vue?vue&type=template&id=61994196&scoped=true&"
import script from "./ICMOERelease.vue?vue&type=script&lang=js&"
export * from "./ICMOERelease.vue?vue&type=script&lang=js&"
import style0 from "./ICMOERelease.vue?vue&type=style&index=0&id=61994196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61994196",
  null
  
)

export default component.exports